/** Owner ruling 43: Hidden is a temporary stance, never an innate or permanent grant. */
export function permanentStatusAllowed(effectId: string): boolean {
    if (effectId.toUpperCase() !== '47667406-1B72-9D60-310B-D8CF6BFE397D') return true;
    console.warn('hidden-never-permanent: Ignored permanent Hidden grant. Use Hide to apply a temporary status.');
    return false;
}
